import { render, staticRenderFns } from "./MilitarySchool.vue?vue&type=template&id=74f7ba43&scoped=true"
import script from "./MilitarySchool.vue?vue&type=script&lang=js"
export * from "./MilitarySchool.vue?vue&type=script&lang=js"
import style0 from "./MilitarySchool.vue?vue&type=style&index=0&id=74f7ba43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f7ba43",
  null
  
)

export default component.exports